import { render, staticRenderFns } from "./FieldReferenceAlignments.vue?vue&type=template&id=171d2181&"
import script from "./FieldReferenceAlignments.vue?vue&type=script&lang=ts&"
export * from "./FieldReferenceAlignments.vue?vue&type=script&lang=ts&"
import style0 from "./FieldReferenceAlignments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports